/**
 * Created by Jerker Nord on 2019-05-28.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ThorGameConfig} from "../ThorGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {ThorGameAssets} from "../ThorGameAssets";

export class ThorLogo extends BaseView {

    public static thorLogo:ThorLogo;

    private _layer:ScalableLayer;
    private _logoContainer:PIXI.Container;
    private _minLogoHeightPortrait:number = 200;
    private _minLogoHeightLandscape:number = 130;
    private _reelTopY:number;
    private _reelWidth:number;
    private _reelHeight:number;
    private _mobileLogo:PIXI.Sprite;
    private _desktopLogo:PIXI.Sprite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.LOGO.name);
        this._reelTopY = GameConfig.instance.REEL_AREA_MASK_RECT != null ? GameConfig.instance.REEL_AREA_MASK_RECT.y : GameConfig.instance.REEL_AREA_POS_Y;
        this._reelWidth = GameConfig.instance.REEL_AREA_WIDTH;
        this._reelHeight = GameConfig.instance.REEL_AREA_HEIGHT;
        ThorLogo.thorLogo = this;
    }

    protected initAnimations():void {
        this._logoContainer = new PIXI.Container();
        this.addChild(this._logoContainer);
        this._layer.addChild(this);

        this._mobileLogo = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_LOGO)[0]);
        this._mobileLogo.anchor.set(0.5, 0.5);
        this._mobileLogo.position.y = -10;
        this._logoContainer.addChild(this._mobileLogo);

        this._desktopLogo = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.INTRO_LOGO_TINY)[0]);
        this._desktopLogo.anchor.set(0.5, 0.5);
        this._desktopLogo.position.y = -10;
        this._desktopLogo.visible = false;
        this._logoContainer.addChild(this._desktopLogo);
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._mobileLogo.visible = true;
            this._desktopLogo.visible = false;
            const spaceHeight:number = (MathHelper.floorToDecimals(this._layer.y / this._layer.scale.y, 0) + this._reelTopY) - 110;
            if(spaceHeight < this._minLogoHeightPortrait) {
                this._logoContainer.visible = false;
                return;
            }

            Helper.fitItemInRectangle(this._logoContainer, new PIXI.Rectangle(
                -this._layer.x / this._layer.scale.x,
                -this._layer.y / this._layer.scale.y,
                this._reelWidth, spaceHeight
            ), 0.7);
            this._logoContainer.visible = true;
        } else {
            this._mobileLogo.visible = true;
            this._desktopLogo.visible = false;
            if(UserAgent.isMobile == true) {
                const spaceHeight:number = (MathHelper.floorToDecimals(this._layer.y / this._layer.scale.y, 0) + this._reelTopY);
                if(spaceHeight < this._minLogoHeightLandscape) {
                    this._mobileLogo.visible = false;
                    this._desktopLogo.visible = true;
                    this._logoContainer.scale.set(1, 1);
                    this._logoContainer.position.set(86, 50);
                    return;
                }

                Helper.fitItemInRectangle(this._logoContainer, new PIXI.Rectangle(
                    -this._layer.x / this._layer.scale.x,
                    -this._layer.y / this._layer.scale.y,
                    ThorGameConfig.instance.GAME_WIDTH, spaceHeight
                ), 0.4);
                this._logoContainer.visible = true;
            } else {
                this._mobileLogo.visible = false;
                this._desktopLogo.visible = true;
                this._logoContainer.position.set(86, 50);
            }
        }
    }
}